import { ActionType, IAction } from "../shared/interfaces/Action";
import { AxiosError } from "axios";
import { API } from "../shared/config/environment";
import { refreshAccessToken } from "./AuthenticationService";
import { authHeader } from "../shared/helpers/AuthHeader";
import { APIResponseOfUserInfo, AuthEndPointsClient, UserInfo } from "./generated";

API.interceptors.request.use(async config => {
	const token = localStorage.getItem("access_token");  // token
	config.headers['Authorization'] = 'Bearer ' + token;
	return config;
},
	error => {
		return Promise.reject(error);
	});

const authentication = new AuthEndPointsClient(undefined, API);

const fetchUserInfoSuccess = (data: UserInfo): IAction => {
	return {
		type: ActionType.FETCH_USER_INFO_SUCCESS,
		payload: data,
	};
};

const fetchUserInfoFailure = (payload: any): IAction => {
	return {
		type: ActionType.FETCH_USER_INFO_FAILURE,
		payload,
	};
};

export const fetchUserInfo = async () => {
	const header = authHeader();
			if (header.Authorization !== undefined) {
				if(new Date(localStorage.getItem("accesstoken_expiry")!) <= new Date())
				{
					const data = await refreshAccessToken();
					// handle ping server error on refresh token expiry
					if (data.type === ActionType.FETCH_ACCESS_TOKEN_FAILURE) {
						console.log("refresh token failed!!");
						localStorage.clear();
						const originURL = window.location.origin;
						window.location.href = originURL;
					}
				}
				// const getUserInfo : any = await API.get(baseURL + `/api/auth/getUserInfo`, {
				// 	headers: authHeader(),
				// })
				const getUserInfo : any = await authentication.getUserInfo(null)
					.then((response: APIResponseOfUserInfo) => {
						let userInfo = new UserInfo();
						if(response && response.result) {
							userInfo = response.result;
							localStorage.setItem("TECToolAuthorizeToken", userInfo.tecToolAuthorizeToken!);
						}
						else {
							let userInfo = new UserInfo();
							userInfo.init({
								userId: "Temp",
								lastName: "Guest",
								firstName: "User",
								displayName: "Guest User"
							});
							return fetchUserInfoSuccess(userInfo);
						}
						return fetchUserInfoSuccess(userInfo);
					})
					.catch(async (error: AxiosError) => {
						if (!error.response || error.response?.status === 401 || error.response?.status === 400) {
							const data = await refreshAccessToken();
							if(data.type === ActionType.FETCH_ACCESS_TOKEN_FAILURE)
							{
								localStorage.clear();
								const originURL = window.location.origin;
								window.location.href = originURL;
							}
						}
						else
						{
							return null;
						}
					});
			  return getUserInfo;
			} else {
				return fetchUserInfoFailure(null);
			}
};